import { render, staticRenderFns } from "./SayfaListesi.vue?vue&type=template&id=fa11ea1c&scoped=true&"
import script from "./SayfaListesi.vue?vue&type=script&lang=js&"
export * from "./SayfaListesi.vue?vue&type=script&lang=js&"
import style0 from "./SayfaListesi.vue?vue&type=style&index=0&id=fa11ea1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa11ea1c",
  null
  
)

export default component.exports